import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface LookupDefinitionsState {
    getSuccess?: any;
    getFailure?: any;
    saveSuccess?: any;
    saveFailure?: any;
    updateSuccess?: any;
    updateFailure?: any;
    deleteSuccess?: any;
    deleteFailure?: any;
    getByIdSuccess?: any;
    getByIdFailure?: any;
}

export const initialState: LookupDefinitionsState = {};

// Feature Selector
export const lookupDefinitionsState = createFeatureSelector<LookupDefinitionsState>('lookupDefinitions');

// Selectors
export const getLookupDefinitionsSuccessData = createSelector(
    lookupDefinitionsState,
    (state: LookupDefinitionsState) => state.getSuccess
);

export const getLookupDefinitionsFailureData = createSelector(
    lookupDefinitionsState,
    (state: LookupDefinitionsState) => state.getFailure
);

export const getLookupDefinitionsByIdSuccessData = createSelector(
  lookupDefinitionsState,
  (state: LookupDefinitionsState) => state.getByIdSuccess
);
export const getLookupDefinitionsByIdFailureData = createSelector(
    lookupDefinitionsState,
    (state: LookupDefinitionsState) => state.getByIdFailure
);

export const saveLookupDefinitionsSuccessData = createSelector(
    lookupDefinitionsState,
    (state: LookupDefinitionsState) => state.saveSuccess
);

export const saveLookupDefinitionsFailureData = createSelector(
    lookupDefinitionsState,
    (state: LookupDefinitionsState) => state.saveFailure
);

export const updateLookupDefinitionsSuccessData = createSelector(
    lookupDefinitionsState,
    (state: LookupDefinitionsState) => state.updateSuccess
);

export const updateLookupDefinitionsFailureData = createSelector(
    lookupDefinitionsState,
    (state: LookupDefinitionsState) => state.updateFailure
);

export const deleteLookupDefinitionsSuccessData = createSelector(
    lookupDefinitionsState,
    (state: LookupDefinitionsState) => state.deleteSuccess
);

export const deleteLookupDefinitionsFailureData = createSelector(
    lookupDefinitionsState,
    (state: LookupDefinitionsState) => state.deleteFailure
);